<template>
  <div class="sort">
    <div class="radio-item" 
      :class="item.isSelected?'selected':''"
      v-for="(item, index) in list" :key="index" 
      :data-index="index" 
      @click="selected">
      <span class="title">{{item.text}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sort',
  props: {
    list: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  methods: {
    selected(e) {
      let i = e.currentTarget.dataset.index
      this.$emit('selectedEvent', i);
    }
  }
}
</script>
<style lang="less" scoped>
.sort {
  background-color:#fff;
  .radio-item {
    display: flex;
    align-items: center;
    // padding: .2rem 0;
    font-size: .34rem;
    line-height: 80px;
    font-weight:400;
    position: relative;
    border-top: 1px solid #F7F7F7;
    .title {
      overflow:hidden;
      text-align: left;
      padding-left:.56rem;
    }
    .title-bob {
      height: .28rem;
      width:.08rem;
      background: #fff;
    }
    i {
      display: block;
      width: 35px ;
      height: 25px ;
      background: url(../../assets/picture/success_yellow.png) ;
      background-size: 100% ;
      position:relative;
      text-align: right;
      font-size: .3rem;
      left: 28%;
    }
  }
  .selected  {
    color: #FFD133FF;
  }
  .selected:after{
    position: absolute;
    content: '';
    width: 35px ;
    height: 25px ;
    background: url(../../assets/picture/success_yellow.png) ;
    background-size: 100% ;
    left: 85% !important;
    top: 28%;
    transform: none !important;
    border: none !important;
  }
}
</style>